<template>
    <div>
        <navbar></navbar>
        <section >
  <div class="container">
    <h1 class="title">
      About Norms and Ratios
    </h1>
    <h2 class="subtitle">
      Global Resource for Industry, Economic and Business Norms and Ratios
    </h2>
<p>
Launched in 2020, NormsandRatios.com is geared to entrepreneurs, small business owners and analysts looking for industry specific economic, financial and business
information.

</p>

<p>
In June 2020, we are launching our industry financial statements -- balance sheets, income statements and industry benchmarks for US companies.

</p>
<p>
Norms and Ratios is a product line developed by Oxxford Information Technology, a data and analytics company serving the banking, insurance and
financial services industries since 1985.

</p>

  </div>
</section>

    </div>
</template>

<script>
import Navbar from "./features/Navbar"
import SampleReports from "./SampleReports"
import BuyReports from "./BuyReports"

export default {
    name: 'Dashboard',
    data() {
        return {
			search: '',
			desc: '',
            books: []
        }
    },
    components: {
        Navbar,
        SampleReports
    },
    mounted() {
        this.fetchBooks();
    },
    methods: {
        fetchBooks() {
        },
        signUp() {
        this.$router.push({ name: "Register" });

        },
        goSampleReports() {
        this.$router.push({ name: "SampleReports" });

        },
	},
}
</script>

<style scoped>
.top-10 {
    margin-top: 10px !important;
}
.grey-background {
    background-color: hsl(0, 0%, 86%) !important;
}

.hero.is-info {
  background: linear-gradient(
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.5)
    ), url('../assets/images/hero/restaurant-hero.png') no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.hero .nav, .hero.is-success .nav {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.hero .subtitle {
  padding: 3rem 0;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue